import styles from './charterFlightsTextComponent.module.scss';

const CharterFlightsTextComponent = () => {
  return (
    <section className="container">
      <div className={styles.content}>
        <h2 className={styles.title}>
          Charter Flights, Built Around Your Schedule
        </h2>
        <div className={styles.text}>
          <p>
            At Hera Flight, private jet charter means freedom, flexibility, and
            premium service on your schedule. Whether you&#39;re flying for
            business efficiency or leisure comfort, our tailored charter
            solutions get you where you need to go with absolute discretion and
            ease.
          </p>
          <p>
            Choose from a wide range of jets, from nimble midsize aircraft for
            regional trips to long-range jets for international travel, all
            maintained and crewed to the highest safety standards. With dynamic
            pricing, personalized trip planning, and dedicated support at every
            step, Hera Flight makes private jet charter straightforward,
            reliable, and luxurious.
          </p>
          <p>
            Fly with confidence, avoid the hassles of commercial travel, and
            experience true point-to-point convenience every time you book a
            private jet with us
          </p>
        </div>
      </div>
    </section>
  );
};

export default CharterFlightsTextComponent;
